import { OutgoingHistoriesGQL } from '@schema';
import { QueryData } from '@shared/apollo/query-actions';
import { NamingConfig } from '@shared/naming/naming-config';

export type OutgoingHistory = Omit<
  QueryData<OutgoingHistoriesGQL, ['irtOutgoingTransmissionHistory']>[number],
  '__typename'
>;

export const OutgoingHistoryNaming = NamingConfig<OutgoingHistory>({
  key: 'OutgoingHistory',
  modelName: { '=1': $localize`Outgoing History`, other: $localize`Outgoing Histories` },
  fieldNames: {
    id: $localize`ID`,
    outboundConfigName: $localize`Outbound Config`,
    outboundConfigUrl: $localize`URL`,
    outboundConfigHttpMethod: $localize`HTTP Method`,
    internalEventName: $localize`Event Type`,
    templateName: $localize`Template`,
    errorMessage: $localize`Error Message`,
    status: $localize`Status`,
    createdUtc: $localize`Created At`,
    deliveryMode: $localize`Delivery Mode`,
    jobRunId: $localize`Job Run`,
  },
});
